export const isOptionSelected = (option, selectedOptions) => {
  // Compare both sides as strings so values match regardless of type: the URL param
  // decoder can yield numbers (e.g. 32) while option values are defined as strings (e.g. '32').
  const selected = (selectedOptions || []).map(String);
  return Array.isArray(option) ? option.every(o => selected.includes(String(o))) : selected.includes(String(option));
};
